import { IHousePlanHit } from '@/lib/search/types';
import { cache } from 'react';

export const fetchAlgoliaPlans = cache(
  async (
    ids: string[],
    studioId: number | undefined,
    baseElevation: boolean = false,
  ): Promise<IHousePlanHit[]> => {
    try {
      const query = new URLSearchParams();

      ids.forEach((id) => {
        query.append('home_plan_id', id);
      });

      if (studioId !== undefined) {
        query.set('location_id', studioId.toString());
      }

      if (baseElevation) {
        query.set('only_base_elevation', 'true');
      }

      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/algolia/home-plans?${query.toString()}`,
        {
          next: { revalidate: 3600 },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to fetch Algolia home plans');
      }

      return await response.json();
    } catch (err) {
      console.error('fetchAlgoliaPlans error:', err);
      return [];
    }
  },
);
